import { Component, OnInit } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { NgwService } from '../../app/ngw.service';
import { NgwPlayer, NgwGame } from '../../app/classes/ngwGame';


@Component({
  selector: 'page-standings',
  templateUrl: 'standings.html',
})
export class Standings implements OnInit  {
 currGame:NgwGame = null;

  constructor(public navCtrl: NavController, public navParams: NavParams, public ngwService: NgwService) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad Standings');
  }


  ngOnInit(): void {
    this.currGame = this.ngwService.currentGame;
    console.log("Standings loaded", this.currGame)
  }

}




// WEBPACK FOOTER //
// ./src/pages/standings/standings.ts